import React from 'react';
import { compose, withProps } from 'recompose';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import PropTypes from 'prop-types';

function handleDragEnd(props, event) {
  props.onMarkerChanged({
    latitude: event.latLng.lat(),
    longitude: event.latLng.lng(),
  });
}

export const Map = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=' +
      process.env.REACT_APP_GOOGLE_MAPS_KEY +
      '&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: (
      <div style={{ height: '440px', width: '100%', position: 'relative' }}>
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          Loading...
        </div>
      </div>
    ),
    containerElement: <div style={{ height: `440px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={17}
    defaultCenter={{ lat: props.latitude, lng: props.longitude }}
  >
    <Marker
      draggable={true}
      position={{ lat: props.latitude, lng: props.longitude }}
      onDragEnd={(event) => handleDragEnd(props, event)}
    />
  </GoogleMap>
));

Map.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  onMarkerChanged: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/shared/map/Map.js